import sanitizeHtml from 'sanitize-html'
import styled from '@emotion/styled'

import { useMemo } from 'react'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import CreateHighlyPersonalizedExperiencesImage from './CreateHighlyPersonalizedExperiencesImage'

const copy = {
  heading: `Create highly-personalized experiences`,
}

export const CreateHighlyPersonalizedExperiences = () => {
  const pageConfig = usePageConfig()
  const descriptions = useMemo(
    () => [
      `Sync your real-time customer profiles from Segment to your data warehouse with <a href="${getAbsoluteUrl(
        `/product/profiles-sync/`,
        pageConfig
      )}">Profiles Sync</a>.`,
      `Enrich your profiles with data from your CRM, support, financial, and other customer systems in your data warehouse.`,
      `Build hyper-targeted audiences that go beyond behavior-based personalization and take into consideration the overall health and happiness of a customer. Then, activate them in all of your downstream destinations with Reverse ETL.`,
    ],
    [pageConfig]
  )
  return (
    <SectionBase variant="2Col" reverse={true}>
      <Section.Copy alignSelf="center">
        <StyledCopyTextBase>
          <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
          {descriptions.map((description, key) => (
            <CopyText.Description
              key={key}
              tag="p"
              dangerouslySetInnerHTML={{
                __html: sanitizeHtml(description, { allowedTags: [`a`] }),
              }}
            />
          ))}
        </StyledCopyTextBase>
      </Section.Copy>
      <Section.Contents>
        <CreateHighlyPersonalizedExperiencesImage alt={`Illustration: ${copy.heading}`} />
      </Section.Contents>
    </SectionBase>
  )
}

const StyledCopyTextBase = styled(CopyTextBase)`
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    max-width: 440px;
  }
`

export default CreateHighlyPersonalizedExperiences
